import { Variable, Model } from 'helper/products/meteorology';

// Defaults ao abrir o Comparador Clássico (#1822, item 5.3). Regra da Bruna
// (reunião 15/07): variável = Precipitação · ambos os modelos = Indicação Met.
// Casamos por id/value case-insensitive (o casing de "indicacaomet" varia entre
// endpoints), com fallback pelo label ("precipita"/"indica") caso o id mude.
export const DEFAULT_VARIABLE_ID = 'prec';
export const DEFAULT_MODEL_VALUE = 'indicacaomet';

/**
 * Id da variável Precipitação nas variáveis do Comparador Clássico ({ id, label }).
 * Devolve o id EXATAMENTE como veio (preserva a caixa original), pois é ele que
 * a query usa.
 */
export function resolveDefaultVariableId(variables: Variable[]): string | undefined {
  const byId = variables.find((v) => v.id.toLowerCase() === DEFAULT_VARIABLE_ID);
  if (byId) return byId.id;
  const byLabel = variables.find((v) => /precipita/i.test(v.label));
  return byLabel?.id;
}

/**
 * Value do modelo Indicação Met nos modelos do Comparador Clássico ({ value, label }).
 * Preserva a caixa original do value.
 */
export function resolveDefaultModelValue(models: Model[]): string | undefined {
  const byValue = models.find((m) => m.value.toLowerCase() === DEFAULT_MODEL_VALUE);
  if (byValue) return byValue.value;
  const byLabel = models.find((m) => /indica/i.test(m.label));
  return byLabel?.value;
}
